import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col ml-3" }
const _hoisted_3 = { class: "timeline-content d-flex" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "card-header border-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Respon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Peserta"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_19 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_presentasi",
  ref: "uploadModalRef"
}
const _hoisted_33 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_34 = { class: "modal-content rounded" }
const _hoisted_35 = { class: "modal-header pb-0 border-0 justify-content-center" }
const _hoisted_36 = {
  key: 0,
  class: "modal-title mb-6"
}
const _hoisted_37 = {
  key: 1,
  class: "modal-title mb-6"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_39 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-xl-6 mb-8" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Pengisi Presentasi", -1)
const _hoisted_43 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "col-xl-6 mb-8" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_48 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-xl-6 mb-8" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Respon", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Respon", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", {
  value: "Cold",
  key: "Cold"
}, "Cold", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", {
  value: "Warm",
  key: "Warm"
}, "Warm", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", {
  value: "Hot",
  key: "Hot"
}, "Hot", -1)
const _hoisted_58 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "col-xl-6 mb-8" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Peserta", -1)
const _hoisted_63 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-xl-6 mb-8" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_69 = { class: "col-xl-6 mb-8" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Proses", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Proses", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", {
  value: "true",
  key: "true"
}, "Sudah", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", {
  value: "false",
  key: "false"
}, "Belum", -1)
const _hoisted_74 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "modal-footer" }
const _hoisted_78 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-success me-3",
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_presentasi",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tambahV()))
                }, " Tambah Presentasi ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              (_ctx.data.tableDataPresentasi.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataPresentasi, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.progressDate), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.actorName), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.processed == true ? "Sudah" : "Belum"), 1),
                        _createElementVNode("td", _hoisted_16, [
                          (item.respon == 'Cold')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Cold "))
                            : _createCommentVNode("", true),
                          (item.respon == 'Warm')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Warm "))
                            : _createCommentVNode("", true),
                          (item.respon == 'Hot')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Hot "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(item.participant), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(item.note.length > 50
                        ? item.note.substring(0, 50) + " ..."
                        : item.note), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            title: "Edit",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.getId(index, item)),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_presentasi"
                          }, _hoisted_25, 8, _hoisted_23),
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            "data-bs-toggle": "tooltip",
                            title: "Hapus",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.handleDelete(index, item))
                          }, _hoisted_28, 8, _hoisted_26)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_29, _hoisted_31))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (_ctx.items.aksi == 'tambah')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_36, " Tambah Presentasi "))
                  : (_openBlock(), _createElementBlock("h5", _hoisted_37, "Update Presentasi")),
                _hoisted_38
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "actorName",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Pengisi Presentasi",
                      modelValue: _ctx.tambahPresentasi.actorName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambahPresentasi.actorName) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.tambahPresentasi.actorName == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.items.erroractorName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "progressDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Tanggal",
                      modelValue: _ctx.tambahPresentasi.progressDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambahPresentasi.progressDate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.tambahPresentasi.progressDate == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.items.errorprogressDate), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50))
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "respon",
                      autocomplete: "off",
                      modelValue: _ctx.tambahPresentasi.respon,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tambahPresentasi.respon) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_54,
                        _hoisted_55,
                        _hoisted_56,
                        _hoisted_57
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.tambahPresentasi.respon == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.items.errorrespon), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_60))
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "participant",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Peserta",
                      modelValue: _ctx.tambahPresentasi.participant,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahPresentasi.participant) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.tambahPresentasi.participant == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.items.errorparticipant), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_65))
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Isi Catatan",
                      name: "note",
                      autocomplete: "off",
                      rows: "5",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tambahPresentasi.note) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.tambahPresentasi.note]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "processed",
                      autocomplete: "off",
                      modelValue: _ctx.tambahPresentasi.processed,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tambahPresentasi.processed) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_71,
                        _hoisted_72,
                        _hoisted_73
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.tambahPresentasi.processed == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.items.errorprocessed), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_76))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.kosongkanVariabel()))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitAdd())),
                  disabled: _ctx.items.disableButton
                }, " Simpan ", 8, _hoisted_78)
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}